import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const UPGRADE_PANEL_NAME = 'upgradePanel';

/** Fonctionnalités [PRO] promues par le menu « Mise à niveau » (paywall). */
export type UpgradeFeatureKey =
  | 'features'
  | 'submissions'
  | 'automations'
  | 'integrations'
  | 'ai';

export interface UpgradePanelData {
  feature: UpgradeFeatureKey;
}

/**
 * Panneau latéral « Mise à niveau [PRO] » : un seul panneau générique, paramétré par
 * la fonctionnalité promue. Résultat : `true` si l'usager a cliqué « Commander »
 * (navigation vers la page de demande), `false` sinon. Même contrat que les
 * autres panneaux (isOpen$ + emitResult, enregistré dans `_panelEntries`).
 */
@Injectable({ providedIn: 'root' })
export class UpgradePanelService {
  private _result$: Subject<boolean> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: UpgradePanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data: UpgradePanelData): Observable<boolean> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<boolean>();
    this._data = data;

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(UPGRADE_PANEL_NAME);
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): UpgradePanelData | null {
    return this._data;
  }

  emitResult(result: boolean): void {
    const sidebar = this._fuseSidebarService.getSidebar(UPGRADE_PANEL_NAME);
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
